import { useLocalStorage } from '@cheqroom/hooks';
import { useFeature } from '@optimizely/react-sdk';

import useOverviewConfig from '../../components/Overview/use-overview-config.hook';
import { useAuth } from '../../context/Authentication.context';
import { FieldType, SystemFieldType } from './types';

const CUSTOMIZE_ITEM_VIEW_DEFAULT_SELECTION = [SystemFieldType.barcode, SystemFieldType.qr, SystemFieldType.created];

type SaveItemFieldIds = (ids: FieldType[]) => void;

export const useItemFieldsConfig = (itemTypeId: string): [FieldType[], SaveItemFieldIds] => {
	const { id: userId } = useAuth();
	const [itemsConfig] = useOverviewConfig<FieldType>({ type: 'items-list', namespace: itemTypeId, view: 'table' });

	const storageKey = `${userId!}app.item-view`;
	const [selectedFieldIds, saveSelectedFieldIds] = useLocalStorage<FieldType[]>(
		storageKey,
		CUSTOMIZE_ITEM_VIEW_DEFAULT_SELECTION
	);

	const [isNewItemsOverviewEnabled] = useFeature('items_overview_refactor');

	return [
		isNewItemsOverviewEnabled
			? (itemsConfig?.inlineFields ?? [])
			: (selectedFieldIds?.map((id) => {
					// Temporary support for renaming of old legacy fields
					// can be removed after once we switch to new overview
					// @ts-expect-error - temporary support for renaming of old legacy fields
					if (id === 'qr') {
						return 'codes';
					}
					// @ts-expect-error - temporary support for renaming of old legacy fields
					if (id === 'barcode') {
						return 'barcodes';
					}

					return id;
				}) as FieldType[]),
		saveSelectedFieldIds,
	];
};

export default useItemFieldsConfig;
